import React from 'react'
import { FiX } from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import IconWrapper from '../../../../../components/FormBuilder/PasswordInput/IconWrapper'
import SidebarHeaderLabel from './SidebarHeaderLabel'
import SidebarHeaderWrapper from './SidebarHeaderWrapper'

function SidebarHeader({ icon, label, toggleSidebar }: ISidebarHeader) {
  return (
    <SidebarHeaderWrapper>
      <div style={{ display: 'flex', maxWidth: '30px', width: '30px' }}>
        {icon}
      </div>
      <div style={{ marginRight: '20px' }} />
      <SidebarHeaderLabel>{label}</SidebarHeaderLabel>
      <Flex alignCenter={true} justifyEnd={true} full={true}>
        <IconWrapper
          alignCenter={true}
          justifyCenter={true}
          onClick={toggleSidebar}
        >
          <FiX size={18} />
        </IconWrapper>
      </Flex>
    </SidebarHeaderWrapper>
  )
}

export default SidebarHeader

export interface ISidebarHeader {
  icon?: JSX.Element | React.ReactNode | null
  label?: string | null
  toggleSidebar: () => void
}
